import {
  IGetNotificationsChannelsParams,
  IGetNotificationsChannelsResponse,
} from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { RequestType, web3Api } from 'store/queries';
import { createQueryFnWithErrorHandler } from 'store/utils/createQueryFnWithErrorHandler';
import { createQuerySelectors } from 'store/utils/createQuerySelectors';

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { fetchNotificationsChannels },
  useFetchNotificationsChannelsQuery,
  useLazyFetchNotificationsChannelsQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchNotificationsChannels: build.query<
      IGetNotificationsChannelsResponse[],
      IGetNotificationsChannelsParams | void
    >({
      queryFn: createQueryFnWithErrorHandler({
        queryFn: async params => {
          const service = MultiService.getService();

          const data = await service
            .getAccountingGateway()
            .getNotificationsChannels(params ?? undefined);

          return { data };
        },
      }),
      providesTags: [RequestType.NotificationsChannel],
    }),
  }),
});

export const {
  selectDataWithFallbackCachedByParams: selectNotificationsChannels,
  selectLoadingCachedByParams: selectNotificationsChannelsLoading,
  selectStateCachedByParams: selectNotificationsChannelsState,
} = createQuerySelectors({
  endpoint: fetchNotificationsChannels,
  fallback: [],
});
